/**
 * Campaigns with this flow — Voluum's cached campaign list (GET /voluum/campaigns).
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { useCampaigns } from '@/hooks/voluum/useVoluum';

import LinkedCampaignsList from './LinkedCampaignsList';

const VoluumLinkedCampaigns: FC<{ flowId: string }> = ({ flowId }) => {
  const query = useCampaigns();
  return (
    <LinkedCampaignsList
      flowId={flowId}
      campaigns={query.data}
      isLoading={query.isLoading}
      trackerName="Voluum"
    />
  );
};

export default VoluumLinkedCampaigns;
